import Axios from "../../configs/axios.config";

// Payroll Dashboard APIs
export const getPayrollDashboard = (params) =>
  Axios.get(`/payrolls/dashboard`, { params })
    .then((response) => response.data.data);

export const getPayrollRuns = (params) =>
  Axios.get(`/payrolls/runs`, { params })
    .then((response) => response.data?.data || response.data || { data: [], meta: {} });

export const getPendingApprovals = (params) =>
  Axios.get(`/payrolls/pending-approvals`, { params })
    .then((response) => response.data?.data || response.data || { data: [] });

// Payroll Run APIs
export const createPayrollRun = (data) =>
  Axios.post(`/payrolls/run`, data)
    .then((response) => response.data.data);

export const getPayrollRunDetail = (runId) =>
  Axios.get(`/payrolls/runs/${runId}`)
    .then((response) => response.data.data);

export const approvePayrollRun = (runId, data) =>
  Axios.post(`/payrolls/runs/${runId}/approve`, data)
    .then((response) => response.data.data);

export const rejectPayrollRun = (runId, data) =>
  Axios.post(`/payrolls/runs/${runId}/reject`, data)
    .then((response) => response.data.data);

export const finalizePayrollRun = (runId, data) =>
  Axios.post(`/payrolls/runs/${runId}/finalize`, data)
    .then((response) => response.data.data);

export const retryPayrollRun = (runId) =>
  Axios.post(`/payrolls/runs/${runId}/retry`)
    .then((response) => response.data.data);

export const getPayrollRunExceptions = (runId, params) =>
  Axios.get(`/payrolls/runs/${runId}/exceptions`, { params })
    .then((response) => response.data);

export const bulkFixExceptions = (runId, data) =>
  Axios.post(`/payrolls/runs/${runId}/bulk-fix-exceptions`, data)
    .then((response) => response.data.data);

// Payroll Run Exports
export const exportPayslips = (runId) =>
  Axios.get(`/payrolls/runs/${runId}/export/payslips`, {
    // responseType: 'blob'
  })
    .then((response) => response.data);

export const exportBankFile = (runId, bankFormat) =>
  Axios.get(`/payrolls/runs/${runId}/export/bank-file`, {
    params: { format: bankFormat },
    responseType: 'blob'
  })
    .then((response) => response.data);

export const exportStatutoryReports = (runId, reportTypes) =>
  Axios.get(`/payrolls/runs/${runId}/export/statutory`, {
    params: { report_types: reportTypes },
    responseType: 'blob'
  })
    .then((response) => response.data);

// Payslip APIs
export const getEmployeePayslips = (employeeId, params) =>
  Axios.get(`/payrolls/employees/${employeeId}/payslips`, { params })
    .then((response) => response.data);

// Get payslip for specific employee and month/year
export const getEmployeePayslipByMonth = (employeeId, month, year) =>
  Axios.get(`/payrolls/employees/${employeeId}/payslip/generate`, {
    params: { month, year }
  })
    .then((response) => response.data);

export const getPayslipPDF = (payslipId) =>
  Axios.get(`/payrolls/payslips/${payslipId}/pdf`, {
    responseType: 'blob'
  })
    .then((response) => response.data);

export const validatePayslipQR = (qrCode) =>
  Axios.post(`/payrolls/payslips/validate-qr`, { qr_code: qrCode })
    .then((response) => response.data.data);

// Statutory Reports APIs
export const generateStatutoryReport = (data) =>
  Axios.post(`/payrolls/statutory-reports/generate`, data)
    .then((response) => response.data.data);

export const getStatutoryReports = (params) =>
  Axios.get(`/payrolls/statutory-reports`, { params })
    .then((response) => response.data);

export const downloadStatutoryReport = (reportId) =>
  Axios.get(`/payrolls/statutory-reports/${reportId}/download`, {
    responseType: 'blob'
  })
    .then((response) => response.data);

// Payroll Cycles
export const getPayrollCycles = (params) =>
  Axios.get(`/payrolls/cycles`, { params })
    .then((response) => response.data);

export const getPayrollCycleDetail = (cycleId) =>
  Axios.get(`/payrolls/cycles/${cycleId}`)
    .then((response) => response.data.data);

// Attendance Roll-up Check
export const checkAttendanceRollup = (periodStart, periodEnd) =>
  Axios.get(`/payrolls/check-attendance-rollup`, {
    params: { period_start: periodStart, period_end: periodEnd }
  })
    .then((response) => response.data.data);

